// extracted by mini-css-extract-plugin
export default {"tickerText":"marqueeComponent_tickerText__eIEOE","blinker":"marqueeComponent_blinker__AeCae","blink":"marqueeComponent_blink__JYNMz"};